"use client";

import { useStrictLocalization } from "@faire/web/common/localization";
import * as React from "react";
import styled, { useTheme } from "styled-components";

import { Option } from "./Option";

const BreadcrumbRow = styled.ol`
  line-height: 16px;
  padding: 16px;
  margin: 0;

  list-style-type: none;

  li {
    display: inline-block;
    padding-right: 4px;
  }
`;

export interface IBreadcrumbOption {
  label: string;
  path?: string;
}

interface IProps {
  className?: string;
  options: IBreadcrumbOption[];
  handleOnClick?: (option: IBreadcrumbOption) => void;
  dataTestId?: string;
  ariaLabel?: string;
}

/**
 * @trackcomponent
 * @link [Docs](https://slate.faire.team/component/breadcrumb)
 */
export const Breadcrumbs: React.FC<IProps> = ({
  className,
  options,
  handleOnClick,
  dataTestId,
  ariaLabel: _ariaLabel,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const ariaLabel =
    _ariaLabel ||
    strictLocalize({
      id: "2ezgqJ",
      defaultMessage: "Breadcrumbs",
      description: {
        text: "Label of the breadcrumbs for navigation",
      },
    });
  const theme = useTheme();
  return (
    <nav aria-label={ariaLabel}>
      <BreadcrumbRow
        className={className}
        data-test-id={dataTestId}
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {options.map((optionData, index) => (
          <Option
            optionData={optionData}
            key={index}
            index={index}
            handleOnClick={handleOnClick}
            isLastIndex={index === options.length - 1}
            theme={theme}
          />
        ))}
      </BreadcrumbRow>
    </nav>
  );
};
